import script from "./ExplanationPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExplanationPreviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ExplanationPreviewComponent.vue?vue&type=style&index=0&id=1fab80b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fab80b2"]])

export default __exports__